import { StyleSheet } from 'react-native';
import { colors } from './services';

// Re-exportar colors para compatibilidade
export { colors };

export const styles = StyleSheet.create({
  container: {
    width: 350,
    height: 850,
    backgroundColor: colors.bgPrimary,
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    borderWidth: 0,
    padding: 12,
    borderRadius: 8,
    backgroundColor: colors.buttonBg,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  buttonHover: {
    backgroundColor: colors.buttonHover,
  },
  buttonText: {
    color: colors.buttonText,
    fontSize: 15,
    lineHeight: 21,
    fontWeight: '500',
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  input: {
    borderWidth: 1,
    borderColor: colors.borderLight,
    padding: 14,
    borderRadius: 8,
    fontSize: 15,
    lineHeight: 21,
    color: colors.textPrimary,
    backgroundColor: colors.bgPrimary,
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  header: {
    backgroundColor: colors.headerBg,
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  headerButton: {
    padding: 8,
  },
  text: {
    color: colors.textPrimary,
    fontSize: 15,
    lineHeight: 21,
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  textLarge: {
    fontSize: 15,
    lineHeight: 21,
    fontWeight: '600',
    color: colors.textPrimary,
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  textSecondary: {
    fontSize: 15,
    lineHeight: 21,
    color: colors.textSecondary,
    fontWeight: '500',
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  textSmall: {
    fontSize: 15,
    lineHeight: 21,
    color: colors.textPrimary,
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  errorText: {
    color: colors.error,
    fontSize: 15,
    lineHeight: 21,
    marginTop: 4,
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  scrollView: {
    flex: 1,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    fontSize: 15,
    lineHeight: 21,
    fontWeight: '500',
    fontFamily: 'Roboto, sans-serif, Arial, sans-serif',
  },
  badgeSuccess: {
    backgroundColor: '#D1FAE5',
    color: colors.success,
  },
  badgeError: {
    backgroundColor: '#FEE2E2',
    color: colors.error,
  },
});

